import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { Nullable } from 'cng-common/models/utils'
import { IFilter, Logic } from 'core-components/types'
import { Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

interface IParams {
  programType?: Nullable<ProgramTypes>
  partnerId?: Nullable<string>
}

export const getPartnerContactsCrud = ({ programType, partnerId }: IParams = {}) => {
  const crud = CrudStore.get(
    CrudStoreItemPartner360.PartnerContacts,
    ['jbpPartnerContacts', programType, partnerId].filter(Boolean).join(':')
  )

  const filters: IFilter[] = []

  if (partnerId) {
    filters.push({
      field: 'PartnerId',
      operator: Operator.EQUAL,
      value: partnerId,
    })
  }

  if (programType) {
    filters.push({
      field: 'ProgramType',
      operator: Operator.EQUAL,
      value: programType,
    })
  }

  crud.setFilter({
    logic: Logic.AND,
    filters: filters,
  })

  crud.setPaging({
    page: 0,
    pageSize: 1000,
  })

  return crud
}
